import { useState, useEffect } from "react";
import axios from "axios";
import { API_BASE_URL } from "../config";

// The delivery charge used to be one global value (Settings) - now each
// restaurant sets its own, so this needs to know which restaurant the
// current cart belongs to. Falls back to the old global Settings value
// (then a historical ৳50 default) when there's no restaurant in the cart
// yet, or the restaurant fetch fails, so checkout never breaks over it.
const DEFAULT_DELIVERY_CHARGE = 50;

export const useDeliveryCharge = (restaurantId) => {
  const [baseDeliveryCharge, setBaseDeliveryCharge] = useState(DEFAULT_DELIVERY_CHARGE);

  useEffect(() => {
    let cancelled = false;

    const fetchSettingsFallback = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/settings`);
        if (!cancelled && typeof response.data?.settings?.deliveryCharge === "number") {
          setBaseDeliveryCharge(response.data.settings.deliveryCharge);
        }
      } catch (error) {
        console.error("Error fetching delivery settings, using default:", error);
      }
    };

    if (restaurantId) {
      axios
        .get(`${API_BASE_URL}/restaurant/${restaurantId}`)
        .then((response) => {
          if (!cancelled && typeof response.data?.restaurant?.deliveryCharge === "number") {
            setBaseDeliveryCharge(response.data.restaurant.deliveryCharge);
          }
        })
        .catch((error) => {
          console.error("Error fetching restaurant delivery charge, falling back:", error);
          if (!cancelled) fetchSettingsFallback();
        });
    } else {
      fetchSettingsFallback();
    }

    return () => {
      cancelled = true;
    };
  }, [restaurantId]);

  return baseDeliveryCharge;
};
